// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invoice-container[data-v-0fde3bf8] {\n  padding: 1rem 0.5rem;\n  border-radius: 0.35rem;\n  background: #F7F7F7;\n  border-left: 0.25rem solid #2DB782 !important;\n}\n.invoice-container[data-v-0fde3bf8] .title-icon {\n  color: #2DB782 !important;\n}\n.invoice-container[data-v-0fde3bf8] .dot {\n  background: #fff !important;\n}\n.invoice-container[data-v-0fde3bf8] .vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n}", ""]);
// Exports
module.exports = exports;
